<template>
  <div>
      <el-button class="el-icon-top clickable primary" @click="backToScoping()" round></el-button>
      <el-button class="el-icon-refresh clickable primary" @click="refreshCards()" round></el-button>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: ['types', 'decks', 'scope'],
  methods: {
    refreshCards() {
      var vm = this
      _.each(this.types, function(val, i) {
        setTimeout(() => vm.$emit('refresh', val.type, vm.decks[vm.scope][val.type]), 30 * i);
      })
      vm.$root.$emit('resetTimer', true, true)
    },
    backToScoping() {
      var vm = this
      vm.$emit('navigate', 'up')
    }
  }
}
</script>

<style>
</style>
